"use client"

import { ModalErrorMessage } from "@/app/error"
import { MakeOfferIcon } from "@/app/icons/make-offer"
import { useConnectStatus } from "@/app/nft/order/widget/actions/use-connect-status"
import { BalanceBlockchainScope } from "@/app/profiles/balance/balance-molecule.reatom"
import { CollectionScope } from "@/app/sdk/anaconda-sdk-scope"
import { useWalletConnect } from "@/app/wallet-connect/hooks"

import { Trans } from "@lingui/react/macro"
import {
  Button,
  type ButtonProps,
  Dialog,
  DialogContent,
  DialogTrigger,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"
import { ScopeProvider } from "bunshi/react"
import { Suspense, useCallback, useState } from "react"
import { ErrorBoundary } from "react-error-boundary"
import { useCollection } from "../store/use-collection"
import { CollectionOfferDialogContentReatom as CollectionOfferDialogContent } from "./dialog-content.reatom"

interface Props {
  trigger?: Omit<ButtonProps, "onClick" | "children">
}

export const CollectionOfferDialog = reatomComponent<Props>(({ trigger }) => {
  const [isOpened, setOpen] = useState(false)
  const collection = useCollection()
  const { status } = useWalletConnect()

  const func = useConnectStatus(() => {})

  const handleOpen = useCallback(
    (open: boolean) => {
      if (status === "connected") {
        setOpen(open)
      } else {
        func()
      }
    },
    [status, func],
  )

  return (
    <Dialog onOpenChange={handleOpen} open={isOpened}>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="inline-flex">
            <DialogTrigger asChild id="collection-offer-dialog">
              <Button {...trigger} className={trigger?.className}>
                <div className="flex items-center gap-2">
                  <MakeOfferIcon />
                  <span className="text-xs uppercase">
                    <span className="hidden md:inline">
                      <Trans>Collection offer</Trans>
                    </span>
                    <span className="inline md:hidden">
                      <Trans>Offer</Trans>
                    </span>
                  </span>
                </div>
              </Button>
            </DialogTrigger>
          </div>
        </TooltipTrigger>
      </Tooltip>
      <DialogContent
        className="max-w-[396px] overflow-x-hidden "
        aria-describedby="collection-offer-dialog"
      >
        <ScopeProvider scope={CollectionScope} value={collection}>
          <ErrorBoundary fallback={<ModalErrorMessage />}>
            <Suspense fallback={null}>
              <ScopeProvider
                scope={BalanceBlockchainScope}
                value={collection.blockchain}
              >
                <CollectionOfferDialogContent onOpenChange={setOpen} />
              </ScopeProvider>
            </Suspense>
          </ErrorBoundary>
        </ScopeProvider>
      </DialogContent>
    </Dialog>
  )
}, "CollectionOfferDialog")
